import PropTypes from 'prop-types';
import { Box, CircularProgress, Divider, Typography, useTheme } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitleDefault from '../default/DialogTitleDefault';
import { useState, useEffect } from 'react';
import { CardViewTicket } from '../../components';
import TicketService from '../../services/tickets.service';

function ModalTicketsPreServicio({id, show, hideModal,item, history}) {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    
    const handleClose = () => hideModal();
    const [tickets, setTickets] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        if(item?.id_t){
            setIsLoading(true);
            TicketService.getByPreServicio(item.id_t).then((resp) => {
                if(Array.isArray(resp)){
                    setTickets(resp);
                } else {
                    setTickets([]);
                }
            }).catch(() => {
                setTickets([]);
            }).finally(() => {
                setIsLoading(false);
            });
        }
    }, [item])
    return (
        <Dialog open={show} disableEscapeKeyDown maxWidth='md' fullWidth className='side'>
            <Box sx={{background: isDarkMode ? '#2d3a52' : '#fff', borderTop: `3px solid ${isDarkMode ? '#3d4a62' : '#e0e0e0'}`}} className='side'>
                <DialogTitleDefault id="add-canal-priv" onClose={handleClose}>
                    <Box sx={{display: 'flex', flexDirection: 'row',justifyContent:'start',alignItems:'center'}}>
                        <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000',fontWeight: 'bold'}} variant='h5' component='div'>{`Pre-Servicio #${item?.id_t} - `}<Box fontWeight='normal' display='inline'>{item?.nombre_t}</Box></Typography>
                    </Box>
                </DialogTitleDefault>
                <DialogContent className='side'>
                    {isLoading ? (
                        <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4}}>
                            <CircularProgress size={36} />
                        </Box>
                    ) : tickets && tickets?.length > 0 ? (
                        tickets?.map((tkI)=>(
                            <CardViewTicket item={tkI} key={tkI?.id_tk} onCloseModal={handleClose} />
                        ))
                    ) : (
                        <Box sx={{display: 'flex', justifyContent: 'center', py: 4}}>
                            <Typography sx={{color: isDarkMode ? '#b0bec5' : '#6b788e'}}>
                                No se encontraron tickets.
                            </Typography>
                        </Box>
                    )}
                </DialogContent>
            </Box>
        </Dialog>
    );
}

ModalTicketsPreServicio.propTypes = {
    show: PropTypes.bool
};

ModalTicketsPreServicio.defaultProps = {
    show: false
};

export default ModalTicketsPreServicio